import { forwardRef as f } from "react";
import { Input as l } from "../../../../Input/Input.js";
import "theme-ui";
import { jsx as p } from "theme-ui/jsx-runtime";
import "../../../../Input/NumberInput/NumberInput.js";
import "../../../../Input/TextArea/TextArea.js";
import { CollapseArrow as d } from "../../../../CollapseArrow/CollapseArrow.js";
const u = f((i, e) => {
  const {
    as: m = l,
    open: s,
    getInputProps: r,
    getToggleButtonProps: o,
    iconSx: c,
    /* eslint-disable @typescript-eslint/no-unused-vars */
    selectedOption: x,
    /* eslint-enable @typescript-eslint/no-unused-vars */
    ...a
  } = i, t = o == null ? void 0 : o(), n = {
    ref: e,
    variant: "ghost",
    endAdornment: /* @__PURE__ */ p(d, {
      open: s,
      sx: c
    }),
    onClick: t == null ? void 0 : t.onClick,
    ...a
  };
  return /* @__PURE__ */ p(m, {
    ...(r == null ? void 0 : r(n)) ?? n
  });
});
u.displayName = "SelectInputTrigger";
export {
  u as SelectInputTrigger
};
